import api from './authService';
import type { User, UserCreate, UserUpdate } from '@types';

// ユーザー一覧取得（管理者のみ）
export const getUsers = async (): Promise<User[]> => {
  const response = await api.get<User[]>('/users/');
  return response.data;
};

// ユーザー作成（管理者のみ）
export const createUser = async (userData: UserCreate): Promise<User> => {
  const response = await api.post<User>('/users/', userData);
  return response.data;
};

// ユーザー更新（管理者のみ）
export const updateUser = async (userId: number, userData: UserUpdate): Promise<User> => {
  const response = await api.patch<User>(`/users/${userId}`, userData);
  return response.data;
};

// ユーザー削除（管理者のみ）
export const deleteUser = async (userId: number): Promise<void> => {
  await api.delete(`/users/${userId}`);
};
